import { useParams } from "react-router-dom";
import { DASHBOARD_ROOT } from "../../components/Routes/routingConstants";
import { useEffect, useState } from "react";
import { Alert } from "reactstrap";

import { useOrganisationDetail } from "../../hooks/useOrganisation";
import { Organisation } from "../../interfaces/models/Organisation";

import { Breadcrumb, COMPANY_NUDGE_SCHEDULE_DAYS } from "../../helper/constants";
import CompanyNudgePlanKanban from "../../components/Compliance/CompanyNudgePlanKanban";
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";

interface RouteParams {
  id: string;
}

const OrganisationComplianceNudgePlansPage = () => {

  const { id } = useParams<RouteParams>(); // Organisation ID

  const [breadcrumbsData, setBreadcrumbsData] = useState<Breadcrumb[]>([
    { name: "Content List", path: `${DASHBOARD_ROOT}/content-management/` },
    { name: "Organisation List", path: `${DASHBOARD_ROOT}/content-management/organisation-list` },
    { name: '...', path: `${DASHBOARD_ROOT}/content-management/organisation-list/${id}` },
    { name: 'Nudge Planner', path: `${DASHBOARD_ROOT}/content-management/organisation-list/${id}/nudge-plans` },
  ]);

  const [organisation, setOrganisation] = useState<Organisation>(null);

  const organisationResult = useOrganisationDetail(id);

    useEffect(() => {
    if(organisationResult.data) {
      const raw = organisationResult.data.organisation as Organisation;
      setOrganisation(raw);
      setBreadcrumbsData(prevData => {
        const updatedData = [...prevData];
        updatedData[updatedData.length - 2] = {
          ...updatedData[updatedData.length - 2], 
          name: raw.name
        };
        return updatedData;
      });
    }
  },[organisationResult.data]);


  return(
    <>
      <Breadcrumbs crumbs={breadcrumbsData} />
      {organisationResult.error && <Alert color="danger">Oops, we’re having trouble getting the Schedules. Please give it a minute, and if it doesn’t resolve, let us know.</Alert>}
      {organisation && 
      <CompanyNudgePlanKanban
        times={organisation.company_policy_nudge_schedules}
        loading={organisationResult.loading}
        hasCRUD={false}
        days={COMPANY_NUDGE_SCHEDULE_DAYS}
      />}
    </>
  )

}


export { OrganisationComplianceNudgePlansPage as OrganisationComplianceNudgePlans };